import React, { useEffect, useState } from "react";
import LabForm from "../form/LabForm";
import axios from "axios";

export default function LabManager() {
  const [labs, setLabs] = useState([]);
  const [editingLabId, setEditingLabId] = useState(null);

  useEffect(() => fetchLabs(), []);

  const fetchLabs = () => {
    axios.get("/api/v1/lab/")
      .then(res => setLabs(res.data))
      .catch(err => console.error(err));
  };

  const handleEdit = (id) => setEditingLabId(id);
  const handleAdd = () => setEditingLabId("new");
  const handleCloseForm = () => {
    setEditingLabId(null);
    fetchLabs();
  };

  return (
    <div>
      <h2>Labs</h2>
      {!editingLabId && <button className="btn btn-success mb-3" onClick={handleAdd}>Add Lab</button>}

      {!editingLabId ? (
        <ul className="list-group">
          {labs.map(lab => (
            <li key={lab.id} className="list-group-item d-flex justify-content-between align-items-center">
              {lab.title}
              <button className="btn btn-sm btn-primary" onClick={() => handleEdit(lab.id)}>Edit</button>
            </li>
          ))}
        </ul>
      ) : (
        <div className="mt-3">
          <button className="btn btn-secondary mb-2" onClick={handleCloseForm}>Back to list</button>
          <LabForm labId={editingLabId === "new" ? null : editingLabId} />
        </div>
      )}
    </div>
  );
}
